import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const fieldErrorCss = css`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: ${withVar(DesignToken.ContentBasicNegative)};
`;

export const CheckboxWithLabelDescription = styled.div`
  margin: 6px 0 0 24px;
`;
